var map = {
	"./bsc.png": 268,
	"./dydx.png": 269,
	"./ethereum.png": 270,
	"./fantom.png": 271,
	"./metamask.png": 120,
	"./polygon.png": 272,
	"./uniswap.png": 273,
	"./xdai.png": 274,
	"./yearn.png": 275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 267;